
































import { Prop, Component, Vue, Mixins } from 'vue-property-decorator';
import TileComponentMixin from '@/mixins/TileComponentMixin';
import BaseNumbersTile, { IBaseNumbersTileConfiguration } from './BaseNumbersTile.vue';
import { Getter } from 'vuex-class';
import { IN2KWaterDepthEvent, N2KTemperatureEventSource, IN2KTemperatureEvent,
    N2KTemperatureEvent, N2KFluidLevelEvent, IN2KGnssEvent, N2KGnssEventType, N2KGnssEventMethod } from '../../common/apis/DeviceApi';
import UserMixin from '@/mixins/UserMixin';

interface ITemperature {
    name: string;
    value: string;
    isOld: boolean;
}

@Component({
    components: {
        BaseNumbersTile,
    },
})
export default class GnssTile extends Mixins(TileComponentMixin, UserMixin) {
    private static priorities: N2KGnssEventType[] = [
        N2KGnssEventType.Glonass,
        N2KGnssEventType.GpsGlonass,
        N2KGnssEventType.GpsBasWaas,
        N2KGnssEventType.GpsBasWaasGlonass,
        N2KGnssEventType.Galileo,
        N2KGnssEventType.Gps,
        N2KGnssEventType.Chayka,
        N2KGnssEventType.Integrated,
        N2KGnssEventType.Surveyed,
    ];

    @Prop({required: false})
    public configuration?: IBaseNumbersTileConfiguration;

    public page: number = 0;


    public get available() {
        if (this.lastEvent) {
            return true;
        }
        return false;
    }

    public get ageInSeconds(): number {
        if (this.lastEvent && this.lastEvent.timestamp) {
            const timestamp = typeof this.lastEvent.timestamp === 'object'
                ? this.lastEvent.timestamp
                : new Date(this.lastEvent.timestamp);

            return (new Date().getDate() - timestamp.getDate()) / 1000;
        }
        return 999;
    }

    public get lastEvent(): IN2KGnssEvent | null {
        const data = this.getGnss(this.deviceNumber);
        let lastEvent: IN2KGnssEvent | null = null;

        if (data) {
            // Find one that is fresh < 30 sec
            for (const priority of GnssTile.priorities) {
                const event = data[priority];
                if (event && event.timestamp && (new Date().getDate() - new Date(event.timestamp).getDate()) / 1000 < 30) {
                    return event;
                }
            }
            // Not found, then lets find one that is old
            for (const priority of GnssTile.priorities) {
                const event = data[priority];
                if (event) {
                    return event;
                }
            }
        }


        if (!lastEvent && this.isDemo) {
            lastEvent = this.demoData;
        }
        return lastEvent;
    }

    public get latitude(): string {
        if (!this.lastEvent || !this.lastEvent.latitude) {
            return '--';
        }
        return this.convertDEGToDMS(this.lastEvent.latitude, true);
    }
    public get longitude(): string {
        if (!this.lastEvent || !this.lastEvent.longitude) {
            return '--';
        }
        return this.convertDEGToDMS(this.lastEvent.longitude, false);
    }

    public get satteliteCount(): string {
        // Seen in real life that sat count can be 0 and 255 if not set
        if (!this.lastEvent || !this.lastEvent.sattelites || this.lastEvent.sattelites === 0 || this.lastEvent.sattelites === 255) {
            return '--';
        }
        return this.lastEvent.sattelites.toFixed(0);
    }

    @Getter('n2k/gnss')
    private getGnss: (deviceNumber: string) => {[type in N2KGnssEventType]?: IN2KGnssEvent} | null;

    private demoData: IN2KGnssEvent | null = null;
    private demoDataInterval: number;

    public convertDEGToDMS(deg: number, isLatitude: boolean) {
        const absolute = Math.abs(deg);
        const degrees = Math.floor(absolute);
        const minutesNotTruncated = (absolute - degrees) * 60;
        const minutes = minutesNotTruncated.toFixed(3);
        // const minutes = Math.floor(minutesNotTruncated);
        // const seconds = ((minutesNotTruncated - minutes) * 60).toFixed(2);

        let direction: string;
        if (isLatitude) {
            direction = deg >= 0 ? 'N' : 'S';
        } else {
            direction = deg >= 0 ? 'E' : 'W';
        }

        return direction  + ' ' + degrees + '°' + minutes + '\''; // + seconds + '"' + direction;
    }

    public mounted() {
        if (this.isDemo) {
            this.generateDemoData();
            this.demoDataInterval = setInterval(this.generateDemoData, 3000);
        }
    }
    public async beforeDestroy() {
        clearInterval(this.demoDataInterval);
    }


    private calculate(value: number, move: number, min: number, max: number): number {
        value += Math.random() * move * 2 - move;
        if (value > max) {
            value = max;
        }
        if (value < min) {
            value = min;
        }
        return value;
    }

    private generateDemoData() {
        const latitude = this.calculate((this.demoData ? this.demoData.latitude : undefined) || 51.341231, 0.01, 48, 55);
        const longitude = this.calculate((this.demoData ? this.demoData.longitude : undefined) || 1.452311, 0.01, 0.5, 3);
        const sattelites = this.calculate((this.demoData ? this.demoData.sattelites : undefined) || 8, 0.5, 8, 12);

        this.demoData = {
            latitude,
            longitude,
            altitude: 2,
            type: N2KGnssEventType.Gps,
            method: N2KGnssEventMethod.NoGnss,
            sattelites,
            hdop: 0,
            pdop: 0,
            sensorNumber: 0,
            deviceNumber: this.deviceNumber,
            timestamp: new Date(),
        };
    }

    private getAgeInSeconds(event: IN2KTemperatureEvent): number {
        if (event && event.timestamp) {
            const timestamp = typeof event.timestamp === 'object'
                ? event.timestamp
                : new Date(event.timestamp);

            return (new Date().getDate() - timestamp.getDate()) / 1000;
        }
        return 999;
    }
}
